import React, { useState, useEffect } from "react";
import {
  Button,
  Container,
  Form,
  Row,
  Col,
  Modal,
  ListGroup,
} from "react-bootstrap";
import "./Store.css";
import { useNavigate, useParams } from "react-router-dom";
import { createStore } from "../../Helpers/API/storeAPI";
import ReactLoading from "react-loading";
import { ToastContainer, toast } from "react-toastify";
import { getDefLatitude, getStreetAddress } from "../../Helpers/Utils/Common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  validateCigarette,
  validateStore,
} from "../../Helpers/Validation/RegistrationValidation";
import InputError from "../../Components/InputError/InputError";
import SignatureCanvas from "react-signature-canvas";
import { db } from "../../Helpers/offline-db/db";
import { useLiveQuery } from "dexie-react-hooks";
import { syncStores } from "../../Helpers/API/storeAPI";
import { getDefAddress, getDefLongitude } from "./../../Helpers/Utils/Common";

function AddStore({ isOnline }) {
  var sigPad = {};
  const navigate = useNavigate();
  const { lat, lng } = useParams();
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState({
    store_date: new Date().toLocaleDateString("en-CA"),
    store_name: "",
    remarks: "",
    store_image: "",
    latitude: lat,
    longitude: lng,
    address: "",
    agent_visit: "",
    poster_priority_1: "",
    poster_priority_2: "",
    flyer: "",
    trade_letter: "",
    reason: "",
    reason_image: "",
    city: "",
    barangay: "",
    street_name: "",
    signature_image: "",
  });

  const [isIllicit, setIsIllicit] = useState("");
  const [hasImage, setHasImage] = useState("");
  const [isQR, setIsQR] = useState("");
  const [isPosterPrio1, setIsPosterPrio1] = useState("");
  const [isPosterPrio2, setIsPosterPrio2] = useState("");
  const [isFlyer, setIsFlyer] = useState("");
  const [isTradeLetter, setIsTradeLetter] = useState("");

  const [addCigar, setAddCigar] = useState(false);
  const [editCigar, setEditCigar] = useState(false);
  const [cigarDetails, setCigarDetails] = useState({
    pack_price: "",
    stick_price: "",
    weekly_sale: "",
    brand_name: "",
    index: "",
  });
  const [cigarArr, setCigarArr] = useState([]);
  const [chosenCigar, setChosenCigar] = useState({});
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [openSync, setOpenSync] = useState(false);
  const [openOffline, setOpenOffline] = useState(false);
  const [isError, setIsError] = useState({
    store_name: false,
    street_name: false,
    barangay: false,
    city: false,
    has_image: false,
    reason_image: false,
    store_image: false,
    agent_visit: false,
    poster_priority_1: false,
    is_poster_priority_1: false,
    poster_priority_2: false,
    is_poster_priority_2: false,
    flyer: false,
    is_flyer: false,
    trade_letter_text: false,
    is_trade_letter: false,
    trade_letter_reason: false,
    trade_letter_signature: false,
    reason: false,
    is_illicit: false,
    qr_code: false,

    entry: false,
    brand_name: false,
    pack_price: false,
    stick_price: false,
    weekly_sale: false,
  });

  const allStores = useLiveQuery(() => db.procastStores.toArray(), []);
  if (!allStores) return null;

  async function addStore() {
    const response = await createStore(
      details,
      cigarArr,
      isIllicit,
      hasImage,
      isPosterPrio1,
      isPosterPrio2,
      isFlyer,
      isQR,
      isTradeLetter
    );
    if (response.data) {
      toast.success("Store Added Succesfully", {
        autoClose: 4000,
        hideProgressBar: true,
        theme: "colored",
      });
      setTimeout(() => {
        navigate("/location");
      }, 2000);
    } else {
      setLoading(false);
      toast.error("Failed to Register Store", {
        autoClose: 4000,
        hideProgressBar: true,
        theme: "colored",
      });
    }
  }

  function handleDetailsChange(e) {
    const { name, value } = e.target;
    setDetails({ ...details, [name]: value });
  }

  function handleCigarDetailsChange(e) {
    const { name, value } = e.target;
    setCigarDetails({ ...cigarDetails, [name]: value });
  }

  function handleCigarEditDetailsChange(e) {
    const { name, value } = e.target;
    setChosenCigar({ ...chosenCigar, [name]: value });
  }

  function handleAddCigar() {
    if (validateCigarette(cigarDetails, setIsError)) {
      const array = [...cigarArr];
      array.push(cigarDetails);
      setCigarArr(array);
      setAddCigar(false);
      setCigarDetails({});
    }
  }

  function handleEditCigar() {
    if (validateCigarette(chosenCigar, setIsError)) {
      const array = [...cigarArr];
      const index = parseInt(chosenCigar.index);
      array.map((data, key) => {
        if (index === parseInt(key)) {
          data["brand_name"] = chosenCigar["brand_name"];
          data["pack_price"] = chosenCigar["pack_price"];
          data["stick_price"] = chosenCigar["stick_price"];
          data["weekly_sale"] = chosenCigar["weekly_sale"];
        }
      });
      setCigarArr(array);
      setEditCigar(false);
      setChosenCigar({});
    }
  }

  function handleOpenAddCigar() {
    setAddCigar(true);
  }

  function handleOpenEditCigar(data, ind) {
    var cigarObj = data;
    cigarObj["index"] = ind;
    setChosenCigar(cigarObj);
    setEditCigar(true);
  }

  function handleDeleteCigar(ind) {
    const array = [...cigarArr];
    const newArray = [];
    const index = parseInt(ind);
    array.map((data, key) => {
      if (parseInt(key) !== index) {
        newArray.push(data);
      }
    });
    setCigarArr(newArray);
  }

  function handleSubmit() {
    if (isTradeLetter === "YES") {
      if (sigPad.isEmpty() === false) {
        details["signature_image"] = sigPad.getTrimmedCanvas().toDataURL();
      } else {
        details["signature_image"] = "";
      }
    }

    setLoading(true);
    if (
      validateStore(
        details,
        cigarArr,
        isIllicit,
        isQR,
        hasImage,
        isPosterPrio1,
        isPosterPrio2,
        isFlyer,
        isTradeLetter,
        setIsError
      )
    ) {
      if (isOnline) {
        addStore();
      } else {
        addStoreOffline();
      }
    } else {
      setLoading(false);
    }
  }
  function handleSubmitSync() {
    if (isTradeLetter === "YES") {
      if (sigPad.isEmpty() === false) {
        details["signature_image"] = sigPad.getTrimmedCanvas().toDataURL();
      } else {
        details["signature_image"] = "";
      }
    }

    setLoading(true);
    if (
      validateStore(
        details,
        cigarArr,
        isIllicit,
        isQR,
        hasImage,
        isPosterPrio1,
        isPosterPrio2,
        isFlyer,
        isTradeLetter,
        setIsError
      )
    ) {
      initiateSyncStores();
    } else {
      setLoading(false);
    }
  }

  async function addStoreOffline() {
    try {
      alert("Hello");
      var timestamp = new Date();
      var store_date = details.store_date;
      var store_name = details.store_name;
      var street_name = details.street_name;
      var barangay = details.barangay;
      var city = details.city;
      var remarks = details.remarks;
      var latitude2 = details.latitude2;
      var longitude2 = details.longitude2;
      var address2 = getStreetAddress();
      var agent_visit = details.agent_visit;
      var poster_priority_1 = details.poster_priority_1;
      var poster_priority_2 = details.poster_priority_2;
      var flyer = details.flyer;
      var is_poster_priority_1 = isPosterPrio2 === "YES" ? "1" : "0";
      var is_poster_priority_2 = isPosterPrio1 === "YES" ? "1" : "0";
      var is_flyer = isFlyer === "YES" ? "1" : "0";
      var trade_letter = details.trade_letter;
      var address1 = getDefAddress();
      var latitude1 = getDefLatitude();
      var longitude1 = getDefLongitude();
      var selling_illicit_cigar = isIllicit === "YES" ? "1" : "0";
      var qr_code = isQR === "YES" ? "1" : "0";
      var store_image, reason_image;
      if (hasImage === "YES") {
        store_image = details.store_image[0];
      }
      if (hasImage === "NO") {
        reason_image = details.reason_image;
      }
      var cigar_arr = cigarArr;
      const id = await db.procastStores.add({
        timestamp,
        store_date,
        store_name,
        street_name,
        barangay,
        city,
        remarks,
        latitude2,
        longitude2,
        address2,
        agent_visit,
        poster_priority_1,
        poster_priority_2,
        flyer,
        is_poster_priority_1,
        is_poster_priority_2,
        is_flyer,
        trade_letter,
        address1,
        latitude1,
        longitude1,
        selling_illicit_cigar,
        qr_code,
        store_image,
        reason_image,
        cigar_arr,
      });

      alert(`Store ${details.store_name} successfully added. Got id ${id}`);
      // fetchOfflineStores();

      toast.success(`Store ${details.store_name} Added Succesfully, ${id}.`, {
        autoClose: 4000,
        hideProgressBar: true,
        theme: "colored",
      });
      setTimeout(() => {
        setOpenOffline(false);
        setOpenConfirmation(false);
        setLoading(false);
        // navigate("/location");
      }, 2000);
    } catch (error) {
      toast.error(
        `Failed to register store ${details.store_name}. Please try again.`,
        {
          autoClose: 4000,
          hideProgressBar: true,
          theme: "colored",
        }
      );
      setTimeout(() => {
        setOpenOffline(false);
        setOpenConfirmation(false);
        setLoading(false);
        // navigate("/location");
      }, 2000);
    }
  }

  async function initiateSyncStores() {
    const response = await syncStores(allStores);

    if (response.data) {
      setOpenSync(false);
      setLoading(false);
      db.procastStores.clear();
    }
  }

  function handleCanvasClear() {
    sigPad.clear();
  }

  function handleOnline() {
    if (isOnline && allStores.length > 0) {
      setOpenSync(true);
    }
  }

  // if (isOnline && allStores?.length > 0) {
  //   handleOnline();
  // }
  return (
    <Container>
      <ToastContainer />
      <Row className="justify-content-md-center p-5 mt-10">
        <Form.Label className="title">Register Store</Form.Label>
        <Form style={{ textAlign: "left" }}>
          <Form.Group className="mb-3" controlId="formGroupStoreName">
            <Form.Label className="font-med">
              Visited On<span className="badge">*</span>
            </Form.Label>
            <Form.Control
              size="sm"
              name="store_date"
              type="date"
              value={details.store_date}
              onChange={handleDetailsChange}
            />
            {/* <InputError isValid={isError.store_name} message={'This field is required*'}/> */}
          </Form.Group>
          <Form.Group className="mb-3" controlId="formGroupStoreName">
            <Form.Label className="font-med">
              Store Name<span className="badge">*</span>
            </Form.Label>
            <Form.Control
              size="sm"
              name="store_name"
              type="text"
              onChange={handleDetailsChange}
            />
            <InputError
              isValid={isError.store_name}
              message={"This field is required*"}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formGroupStoreName">
            <Form.Label className="font-med">
              Street Name<span className="badge">*</span>
            </Form.Label>
            <Form.Control
              size="sm"
              name="street_name"
              type="text"
              onChange={handleDetailsChange}
            />
            <InputError
              isValid={isError.street_name}
              message={"This field is required*"}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formGroupStoreName">
            <Form.Label className="font-med">
              Barangay<span className="badge">*</span>
            </Form.Label>
            <Form.Control
              size="sm"
              name="barangay"
              type="text"
              onChange={handleDetailsChange}
            />
            <InputError
              isValid={isError.barangay}
              message={"This field is required*"}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formGroupStoreName">
            <Form.Label className="font-med">
              City/Municipality<span className="badge">*</span>
            </Form.Label>
            <Form.Control
              size="sm"
              name="city"
              type="text"
              onChange={handleDetailsChange}
            />
            <InputError
              isValid={isError.city}
              message={"This field is required*"}
            />
          </Form.Group>
          {/* <Form.Group className="mb-3" controlId="formGroupRemarks">
                    <Form.Label className="font-med">Remarks</Form.Label>
                    <Form.Control size='sm' type="text" name="remarks" onChange={handleDetailsChange}/>
                </Form.Group> */}
          <Form.Group className="mb-3" controlId="formGroupStoreImage">
            <Form.Label className="font-med">
              Store Image<span className="badge">*</span>
            </Form.Label>
            {["radio"].map((type) => (
              <div key={`img-${type}`} className="mb-3">
                <Form.Check
                  inline
                  label="YES"
                  name="group2"
                  type={type}
                  id={`img-${type}-1`}
                  onClick={() => {
                    setHasImage("YES");
                    setDetails({ ...details, reason_image: "" });
                  }}
                />
                <Form.Check
                  inline
                  label="NO"
                  name="group2"
                  type={type}
                  id={`img-${type}-2`}
                  onClick={() => {
                    setHasImage("NO");
                    setDetails({ ...details, store_image: "" });
                  }}
                />
              </div>
            ))}
            <InputError
              isValid={isError.has_image}
              message={"This field is required*"}
            />
            {hasImage === "YES" && (
              <>
                <Form.Control
                  size="sm"
                  accept="image/*"
                  id="icon-button-file"
                  type="file"
                  name="store_image"
                  onChange={(e) =>
                    setDetails({ ...details, store_image: e.target.files })
                  }
                />
                <InputError
                  isValid={isError.store_image}
                  message={"This field is required*"}
                />
              </>
            )}
            {hasImage === "NO" && (
              <Form.Group className="mb-3" controlId="formGroupRemarks">
                <Form.Label className="font-med">
                  Rason bakit ayaw magbahagi ng larawan
                  <span className="badge">*</span>
                </Form.Label>
                <textarea
                  type="text"
                  name="reason_image"
                  className="form-control"
                  id="address"
                  aria-describedby="address"
                  onChange={handleDetailsChange}
                ></textarea>
                <InputError
                  isValid={isError.reason_image}
                  message={"This field is required*"}
                />
                {/* <Form.Control size='sm' type="text" name="reason" onChange={handleDetailsChange}/> */}
              </Form.Group>
            )}

            {/* <InputError isValid={isError.has_image} message={'This field is required*'}/> */}
          </Form.Group>
          <hr />
          <Form.Group className="mb-3" controlId="formGroupStoreImage">
            <Form.Label className="font-med">
              Binibisita ng Ahente<span className="badge">*</span>
            </Form.Label>
            <Form.Select
              size="sm"
              name="agent_visit"
              onChange={handleDetailsChange}
            >
              <option defaultValue>Pumili</option>
              <option>PMFTC/Marlboro</option>
              <option>JTI/Mighty Winston</option>
              <option>Both</option>
              <option>Walang bumibisita</option>
            </Form.Select>
            <InputError
              isValid={isError.agent_visit}
              message={"This field is required*"}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formGroupRemarks">
            <Form.Label className="font-med">
              Poster Priority 1 (Palatandaan)<span className="badge">*</span>
            </Form.Label>
            {["radio"].map((type) => (
              <div key={`inline-${type}`} className="mb-3">
                <Form.Check
                  inline
                  label="YES"
                  name="group1pos1"
                  type={type}
                  id={`inline-${type}-1`}
                  onClick={() => setIsPosterPrio1("YES")}
                />
                <Form.Check
                  inline
                  label="NO"
                  name="group1pos1"
                  type={type}
                  id={`inline-${type}-2`}
                  onClick={() => setIsPosterPrio1("NO")}
                />
              </div>
            ))}
            <InputError
              isValid={isError.is_poster_priority_1}
              message={"This field is required*"}
            />
            {isPosterPrio1 === "NO" && (
              <Form.Group className="mb-3" controlId="formGroupRemarks">
                <Form.Label className="font-med">
                  Rason<span className="badge">*</span>
                </Form.Label>
                <textarea
                  type="text"
                  name="poster_priority_1"
                  className="form-control"
                  id="address"
                  aria-describedby="address"
                  onChange={handleDetailsChange}
                ></textarea>
                <InputError
                  isValid={isError.poster_priority_1}
                  message={"This field is required*"}
                />
              </Form.Group>
            )}
          </Form.Group>
          <Form.Group className="mb-3" controlId="formGroupRemarks">
            <Form.Label className="font-med">
              Poster Priority 2 (Babala)<span className="badge">*</span>
            </Form.Label>
            {["radio"].map((type) => (
              <div key={`inline-pos2-${type}`} className="mb-3">
                <Form.Check
                  inline
                  label="YES"
                  name="group1pos2"
                  type={type}
                  id={`inline-pos2-${type}-1`}
                  onClick={() => setIsPosterPrio2("YES")}
                />
                <Form.Check
                  inline
                  label="NO"
                  name="group1pos2"
                  type={type}
                  id={`inline-pos2-${type}-2`}
                  onClick={() => setIsPosterPrio2("NO")}
                />
              </div>
            ))}
            <InputError
              isValid={isError.is_poster_priority_2}
              message={"This field is required*"}
            />
            {isPosterPrio2 === "NO" && (
              <Form.Group className="mb-3" controlId="formGroupRemarks">
                <Form.Label className="font-med">
                  Rason<span className="badge">*</span>
                </Form.Label>
                <textarea
                  type="text"
                  name="poster_priority_2"
                  className="form-control"
                  id="address"
                  aria-describedby="address"
                  onChange={handleDetailsChange}
                ></textarea>
                <InputError
                  isValid={isError.poster_priority_2}
                  message={"This field is required*"}
                />
              </Form.Group>
            )}
            {/* <Form.Control size='sm' type="text" name="poster_priority_2" onChange={handleDetailsChange}/>
                    <InputError isValid={isError.poster_priority_2} message={'This field is required*'}/> */}
          </Form.Group>
          <Form.Group className="mb-3" controlId="formGroupRemarks">
            <Form.Label className="font-med">
              Flyer<span className="badge">*</span>
            </Form.Label>
            {["radio"].map((type) => (
              <div key={`inline-flyer-${type}`} className="mb-3">
                <Form.Check
                  inline
                  label="YES"
                  name="group1flyer"
                  type={type}
                  id={`inline-flyer-${type}-1`}
                  onClick={() => setIsFlyer("YES")}
                />
                <Form.Check
                  inline
                  label="NO"
                  name="group1flyer"
                  type={type}
                  id={`inline-flyer-${type}-2`}
                  onClick={() => setIsFlyer("NO")}
                />
              </div>
            ))}
            <InputError
              isValid={isError.is_flyer}
              message={"This field is required*"}
            />
            {isFlyer === "NO" && (
              <Form.Group className="mb-3" controlId="formGroupRemarks">
                <Form.Label className="font-med">
                  Rason<span className="badge">*</span>
                </Form.Label>
                <textarea
                  type="text"
                  name="flyer"
                  className="form-control"
                  id="address"
                  aria-describedby="address"
                  onChange={handleDetailsChange}
                ></textarea>
                <InputError
                  isValid={isError.flyer}
                  message={"This field is required*"}
                />
              </Form.Group>
            )}
            {/* <Form.Control size='sm' type="text" name="flyer" onChange={handleDetailsChange}/>
                    <InputError isValid={isError.flyer} message={'This field is required*'}/> */}
          </Form.Group>
          <Form.Group className="mb-3" controlId="formGroupRemarks">
            <Form.Label className="font-med">
              Trade Letter<span className="badge">*</span>
            </Form.Label>
            <Form.Control
              size="sm"
              type="text"
              name="trade_letter"
              onChange={handleDetailsChange}
            />
            <InputError
              isValid={isError.trade_letter_text}
              message={"This field is required*"}
            />
            {/* {['radio'].map((type) => (
                        <div key={`inline-trade-${type}`} className="mb-3">
                        <Form.Check
                            inline
                            label="YES"
                            name="group1trade"
                            type={type}
                            id={`inline-trade-${type}-1`}
                            onClick={()=>setIsTradeLetter("YES")}
                        />
                        <Form.Check
                            inline
                            label="NO"
                            name="group1trade"
                            type={type}
                            id={`inline-trade-${type}-2`}
                            onClick={()=>setIsTradeLetter("NO")}
                        />
                        </div>
                    ))}
                    <InputError isValid={isError.is_trade_letter} message={'This field is required*'}/>
                    {isTradeLetter === "NO" &&
                    <Form.Group className="mb-3" controlId="formGroupRemarks">
                    <Form.Label className="font-med">Rason<span className='badge'>*</span></Form.Label>
                        <textarea type="text" name="trade_letter" className="form-control" id="address" aria-describedby="address" onChange={handleDetailsChange}></textarea>
                        <InputError isValid={isError.trade_letter_reason} message={'This field is required*'}/>
                    </Form.Group>
                    }
                    {isTradeLetter === "YES" &&
                    <Form.Group className="mb-3" controlId="formGroupRemarks">
                    <Form.Label className="font-med">Signature<span className='badge'>*</span></Form.Label>
                        <Col lg={12} sm={12}>
                            <SignatureCanvas penColor='black'
                            canvasProps={{width: 300, height: 200, className: 'sigCanvas'}}
                            backgroundColor={'rgba(255,219,201)'} 
                            ref={(ref) => { sigPad = ref }}/>
                        </Col>
                        <InputError isValid={isError.trade_letter_signature} message={'This field is required*'}/>
                        <Button size='sm'  onClick={handleCanvasClear} style={{background:"#ffc300", border:"#ffc300", fontFamily:"var(--font-medium)"}}>
                        Clear
                        </Button>

                    </Form.Group>
                    
                    } */}
          </Form.Group>
          {/* <Form.Group className="mb-3" controlId="formGroupRemarks">
                    <Form.Label className="font-med">Rason bakit ayaw magpa-install ng poster or ayaw sagutin ang survey<span className='badge'>*</span></Form.Label>
                    <textarea type="text" name="reason" className="form-control" id="address" aria-describedby="address" onChange={handleDetailsChange}></textarea>
                    <InputError isValid={isError.reason} message={'This field is required*'}/>
                </Form.Group> */}
          <Form.Group className="mb-3" controlId="formGroupRemarks">
            <Form.Label className="font-med">
              Nakadisplay ba ang illicit cigarette sa tindahan
              <span className="badge">*</span>
            </Form.Label>
            {["radio"].map((type) => (
              <div key={`inline-cigar-${type}`} className="mb-3">
                <Form.Check
                  inline
                  label="YES"
                  name="group1cigar"
                  type={type}
                  id={`inline-cigar-${type}-1`}
                  onClick={() => setIsIllicit("YES")}
                />
                <Form.Check
                  inline
                  label="NO"
                  name="group1cigar"
                  type={type}
                  id={`inline-cigar-${type}-2`}
                  onClick={() => setIsIllicit("NO")}
                />
              </div>
            ))}
            <InputError
              isValid={isError.is_illicit}
              message={"This field is required*"}
            />
          </Form.Group>
          <hr />

          <Row>
            <Col xs={9} md={11} className="pl-2 pt-1">
              <Form.Label className="font-med">
                Cigarette Sale Details
              </Form.Label>
            </Col>
            <Col xs={3} md={1}>
              <Button
                size="sm"
                className="confirm-btn"
                onClick={handleOpenAddCigar}
              >
                Add
              </Button>
            </Col>
            {/* <InputError isValid={isError.entry} message={'Cigarette Sale Details must not be empty*'}/> */}
          </Row>
          <ListGroup>
            {cigarArr.map((data, key) => {
              return (
                <ListGroup.Item>
                  <Row>
                    <Col xs={8} md={10} className="list-item-name">
                      {data.brand_name}
                    </Col>
                    <Col xs={2} md={1}>
                      <span onClick={() => handleOpenEditCigar(data, key)}>
                        <FontAwesomeIcon
                          icon={"fa-pen"}
                          alt={"lock"}
                          aria-hidden="true"
                          style={{ color: "#ffc300", cursor: "pointer" }}
                        />
                      </span>
                    </Col>
                    <Col xs={2} md={1}>
                      <span onClick={() => handleDeleteCigar(key)}>
                        <FontAwesomeIcon
                          icon={"fa-trash"}
                          alt={"lock"}
                          aria-hidden="true"
                          style={{ color: "#ff3c38", cursor: "pointer" }}
                        />
                      </span>
                    </Col>
                  </Row>
                </ListGroup.Item>
              );
            })}
          </ListGroup>
          <hr />
          <Form.Group className="mb-3" controlId="formGroupRemarks">
            <Form.Label className="font-med">
              Liked <strong>Fight It QR Code</strong>?
              <span className="badge">*</span>
            </Form.Label>
            {["radio"].map((type) => (
              <div key={`inlinechu-${type}`} className="mb-3">
                <Form.Check
                  inline
                  label="YES"
                  name="group2qr"
                  type={type}
                  id={`inlinechu-${type}-1`}
                  onClick={() => setIsQR("YES")}
                />
                <Form.Check
                  inline
                  label="NO"
                  name="group2qr"
                  type={type}
                  id={`inlinechu-${type}-2`}
                  onClick={() => setIsQR("NO")}
                />
              </div>
            ))}
            <InputError
              isValid={isError.qr_code}
              message={"This field is required*"}
            />
          </Form.Group>
          <Form.Group className="mt-3 mb-3" controlId="formGroupSubmit">
            {loading ? (
              <Row className="justify-content-md-center">
                <Col md={1} sm={1} xs={1} className="left-38">
                  <ReactLoading
                    type="spinningBubbles"
                    color="#ff5500"
                    height={100}
                    width={50}
                  />
                </Col>
              </Row>
            ) : (
              <Button
                variant="primary"
                size="md"
                className="full-width-btn confirm-btn"
                onClick={() => setOpenConfirmation(true)}
              >
                Submit
              </Button>
            )}
          </Form.Group>
          <Form.Group className="mt-3 mb-3" controlId="formGroupSync">
            <Button
              variant="primary"
              size="md"
              className="full-width-btn confirm-btn"
              onClick={() => setOpenSync(true)}
            >
              Sync
            </Button>
          </Form.Group>
        </Form>
      </Row>

      {/* EDIT ILLICIT CIGAR STORE DETAILS */}
      <Modal
        show={editCigar}
        onHide={() => setEditCigar(false)}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Form.Label className="title mt-2">Edit Product</Form.Label>
        </Modal.Header>
        <Modal.Body>
          <Row className="justify-content-md-center">
            <Form>
              <Form.Group className="mb-3" controlId="formGroupRemarks">
                <Form.Label className="font-med">Brand Name</Form.Label>
                <Form.Control
                  size="sm"
                  type="text"
                  name="brand_name"
                  value={chosenCigar.brand_name}
                  onChange={handleCigarEditDetailsChange}
                />
                <InputError
                  isValid={isError.brand_name}
                  message={"This field is required*"}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formGroupRemarks">
                <Form.Label className="font-med">Pack Price</Form.Label>
                <Form.Control
                  size="sm"
                  type="number"
                  name="pack_price"
                  value={chosenCigar.pack_price}
                  onChange={handleCigarEditDetailsChange}
                />
                <InputError
                  isValid={isError.pack_price}
                  message={"Price Invalid"}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formGroupRemarks">
                <Form.Label className="font-med">Stick Price</Form.Label>
                <Form.Control
                  size="sm"
                  type="number"
                  name="stick_price"
                  value={chosenCigar.stick_price}
                  onChange={handleCigarEditDetailsChange}
                />
                <InputError
                  isValid={isError.stick_price}
                  message={"Price Invalid"}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formGroupRemarks">
                <Form.Label className="font-med">Sold Per Week</Form.Label>
                <Form.Control
                  size="sm"
                  type="text"
                  name="weekly_sale"
                  value={chosenCigar.weekly_sale}
                  onChange={handleCigarEditDetailsChange}
                />
                <InputError
                  isValid={isError.weekly_sale}
                  message={"This field is required*"}
                />
              </Form.Group>
              <Form.Group className="mt-3 mb-3" controlId="formGroupSubmit">
                <Button
                  variant="primary"
                  size="md"
                  className="full-width-btn danger-btn mb-2"
                  onClick={() => setEditCigar(false)}
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  size="md"
                  className="full-width-btn confirm-btn"
                  onClick={handleEditCigar}
                >
                  Edit
                </Button>
              </Form.Group>
            </Form>
          </Row>
        </Modal.Body>
      </Modal>

      {/* ADD ILLICIT CIGAR STORE DETAILS */}
      <Modal
        show={addCigar}
        onHide={() => setAddCigar(false)}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Form.Label className="title mt-2">Add Product</Form.Label>
        </Modal.Header>
        <Modal.Body>
          <Row className="justify-content-md-center">
            <Form>
              <Form.Group className="mb-3" controlId="formGroupRemarks">
                <Form.Label className="font-med">Brand Name</Form.Label>
                <Form.Control
                  size="sm"
                  type="text"
                  name="brand_name"
                  onChange={handleCigarDetailsChange}
                />
                <InputError
                  isValid={isError.brand_name}
                  message={"This field is required*"}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formGroupRemarks">
                <Form.Label className="font-med">Pack Price</Form.Label>
                <Form.Control
                  size="sm"
                  type="number"
                  name="pack_price"
                  onChange={handleCigarDetailsChange}
                />
                <InputError
                  isValid={isError.pack_price}
                  message={"Price Invalid"}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formGroupRemarks">
                <Form.Label className="font-med">Stick Price</Form.Label>
                <Form.Control
                  size="sm"
                  type="number"
                  name="stick_price"
                  onChange={handleCigarDetailsChange}
                />
                <InputError
                  isValid={isError.stick_price}
                  message={"Price Invalid"}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formGroupRemarks">
                <Form.Label className="font-med">Sold Per Week</Form.Label>
                <Form.Control
                  size="sm"
                  type="text"
                  name="weekly_sale"
                  onChange={handleCigarDetailsChange}
                />
                <InputError
                  isValid={isError.weekly_sale}
                  message={"This field is required*"}
                />
              </Form.Group>
              <Form.Group className="mt-3 mb-3" controlId="formGroupSubmit">
                <Button
                  variant="primary"
                  size="md"
                  className="full-width-btn confirm-btn"
                  onClick={handleAddCigar}
                >
                  Add
                </Button>
              </Form.Group>
            </Form>
          </Row>
        </Modal.Body>
      </Modal>

      {/* CONFIRMATION */}
      <Modal
        show={openConfirmation}
        onHide={() => setOpenConfirmation(false)}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Form.Label className="title mt-2">Confirmation</Form.Label>
        </Modal.Header>
        <Modal.Body>
          <Row className="justify-content-md-center">
            <Form>
              <Form.Group className="mb-3" controlId="formGroupRemarks">
                <Form.Label className="font-med">
                  Are you sure the fields are <strong>correct</strong> and{" "}
                  <strong>final</strong>?
                </Form.Label>
                {/* <Form.Control size='sm' type="text" name="brand_name" onChange={handleCigarDetailsChange}/>
                            <InputError isValid={isError.brand_name} message={'This field is required*'}/> */}
              </Form.Group>

              <Form.Group className="mt-3 mb-3" controlId="formGroupSubmit">
                <Row className="justify-content-center">
                  <Col md={4} lg={4} sm={4} xs={4}>
                    <Button
                      variant="primary"
                      size="md"
                      className="full-width-btn confirm-btn"
                      onClick={handleSubmit}
                    >
                      YES
                    </Button>
                  </Col>
                  <Col md={4} lg={4} sm={4} xs={4}>
                    <Button
                      variant="primary"
                      size="md"
                      className="full-width-btn confirm-btn"
                      onClick={() => setOpenConfirmation(false)}
                    >
                      NO
                    </Button>
                  </Col>
                </Row>
              </Form.Group>
            </Form>
          </Row>
        </Modal.Body>
      </Modal>

      <Modal
        show={openSync}
        onHide={() => setOpenConfirmation(false)}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Form.Label className="title mt-2">Sync Data</Form.Label>
        </Modal.Header>
        <Modal.Body>
          <Row className="justify-content-md-center">
            <Form>
              <Form.Group className="mb-3" controlId="formGroupRemarks">
                <Form.Label className="font-med">
                  Sync encoded stores to database?
                </Form.Label>
                {/* <Form.Control size='sm' type="text" name="brand_name" onChange={handleCigarDetailsChange}/>
                            <InputError isValid={isError.brand_name} message={'This field is required*'}/> */}
              </Form.Group>

              <Form.Group className="mt-3 mb-3" controlId="formGroupSubmit">
                <Row className="justify-content-center">
                  <Col md={4} lg={4} sm={4} xs={4}>
                    <Button
                      variant="primary"
                      size="md"
                      className="full-width-btn confirm-btn"
                      onClick={initiateSyncStores}
                    >
                      YES
                    </Button>
                  </Col>
                  <Col md={4} lg={4} sm={4} xs={4}>
                    <Button
                      variant="primary"
                      size="md"
                      className="full-width-btn confirm-btn"
                      onClick={() => setOpenConfirmation(false)}
                    >
                      NO
                    </Button>
                  </Col>
                </Row>
              </Form.Group>
            </Form>
          </Row>
        </Modal.Body>
      </Modal>

      {/* SYNC PROMPT */}
      {/* <Modal
        show={openSync}
        onHide={() => setOpenSync(false)}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Header>
          <Form.Label className="title mt-2">Sync Data</Form.Label>
        </Modal.Header>
        <Modal.Body>
          <Row className="justify-content-md-center">
            <Form>
              <Form.Group className="mb-3" controlId="formGroupRemarks">
                <Form.Label className="font-med">
                  You are now connected to the internet. Sync encoded stores
                  now.
                </Form.Label>

              </Form.Group>

              <Form.Group className="mt-3 mb-3" controlId="formGroupSubmit">
                <Row className="justify-content-center">
                  <Col md={4} lg={4} sm={4} xs={4}>
                    <Button
                      variant="primary"
                      size="md"
                      className="full-width-btn confirm-btn"
                      onClick={initiateSyncStores}
                    >
                      SYNC
                    </Button>
                  </Col>
                
                </Row>
              </Form.Group>
            </Form>
          </Row>
        </Modal.Body>
      </Modal> */}

      {/* OFFLINE PROMPT */}
      <Modal
        show={openOffline}
        onHide={() => setOpenOffline(false)}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Form.Label className="title mt-2">No internet connection</Form.Label>
        </Modal.Header>
        <Modal.Body>
          <Row className="justify-content-md-center">
            <Form>
              <Form.Group className="mb-3" controlId="formGroupRemarks">
                <Form.Label className="font-med">
                  You are not connected to the internet. Save encoded stores
                  temporarily on your device and sync it when you're back
                  online.
                </Form.Label>
                {/* <Form.Control size='sm' type="text" name="brand_name" onChange={handleCigarDetailsChange}/>
                            <InputError isValid={isError.brand_name} message={'This field is required*'}/> */}
              </Form.Group>

              <Form.Group className="mt-3 mb-3" controlId="formGroupSubmit">
                <Row className="justify-content-center">
                  <Col md={4} lg={4} sm={4} xs={4}>
                    <Button
                      variant="primary"
                      size="md"
                      className="full-width-btn confirm-btn"
                      onClick={addStoreOffline}
                    >
                      OKAY
                    </Button>
                  </Col>
                  {/* <Col md={4} lg={4} sm={4} xs={4}>
                    <Button
                      variant="primary"
                      size="md"
                      className="full-width-btn confirm-btn"
                      onClick={() => setOpenConfirmation(false)}
                    >
                      NO
                    </Button> */}
                  {/* </Col> */}
                </Row>
              </Form.Group>
            </Form>
          </Row>
        </Modal.Body>
      </Modal>
    </Container>
  );
}

export default AddStore;
